import React, { useState, useEffect } from "react";
import { useFetchLeaderBoard } from "../../hooks/api/fetch";
import "./QwizLeaderboard.css";
import Leaderboards from "./LeaderboardDisplay";
import AuthLayout from "../../components/layout/AuthLayout";
import Socket from "../../components/Socket/Socket";
import ErrorIcon from "@mui/icons-material/Error";
import useHomepageLogic from "../homepage/useHomepageLogic";
import { useLogEvent } from "../../hooks/api/post";

export default function QwizLeaderboard() {
  const [quizID, setQuizID] = useState(sessionStorage.getItem("quizID"));
  const [reloader, setReloader] = useState(0);
  const [showPrevious, setShowPrevious] = useState(false);
  const [active, setActive] = useState("thisweek");

  const userData = JSON.parse(sessionStorage.getItem("ccAuth"));
  const userId = userData?.user?.id || userData?.id;

  const { fetchAllLeaderboardData, isLoading, error } = useFetchLeaderBoard(quizID);
  const { fetchGames } = useHomepageLogic();
  const { mutate: logEvent } = useLogEvent();


  useEffect(() => {
    if (!quizID) return;

    const logLeaderboardStatus = async () => {
      try {
        if (error) {
          const status = error?.response?.status;
          let action_type = "Leaderboard_failed";

          if (status === 500) action_type = "Leaderboard_pending";
          else if (status === 400 || status === 404) action_type = "Leaderboard_failed";

          logEvent({
            userId,
            action_type,
          });
          return;
        }

        // success case
        if (fetchAllLeaderboardData?.data) {
          logEvent({
            userId,
            action_type: "Leaderboard_success",
          });
        }
      } catch (err) {
        logEvent({
          userId,
          action_type: "Leaderboard_failed",
        });
      }
    };

    logLeaderboardStatus();
  }, [quizID, fetchAllLeaderboardData, error, userId, logEvent]);


  let TopWinners = fetchAllLeaderboardData?.data?.slice(0, 3) || [];
  let sortedArrayCurrent = [...TopWinners].sort((a, b) => b - a);
  const players = fetchAllLeaderboardData?.data?.slice(3) || [];

  const middleIndex = Math.floor(TopWinners.length / 2);
  const firstElement = TopWinners.shift();
  const rearrangedArray = [
    ...(TopWinners ?? []).slice(0, middleIndex),
    firstElement,
    ...(TopWinners ?? []).slice(middleIndex),
  ];

  // Toggle week
  const ActiveScreen = (id) => {
    setActive(id);
  };

  return (
    <AuthLayout>
      <main className="leaderboardsection">
        <h1 className="leaderboarHeading">Leaderboard</h1>

        <section className="leaderboard">
          <div className="px-4 mb-4">
            <select
              name=""
              id=""
              className="select select-bordered w-full max-w-sm bg-[#61A641] text-white"
              onChange={(e) => setQuizID(e.target.value)}
              value={quizID || ""}
            >
              <option value="">Select Game</option>
              {fetchGames?.data?.data?.allGames?.map((game) => (
                <option key={game?.id} value={game?.id}>
                  {game?.title}
                </option>
              ))}
            </select>
          </div>

          {showPrevious ? (
            <>
              {fetchAllLeaderboardData?.lastWeekLeaderboard?.length < 1 ? (
                <div className="leaderboardDataError">
                  <ErrorIcon />
                  No leaderboard data for last week.
                </div>
              ) : (
                <Leaderboards
                  TopWinners={fetchAllLeaderboardData?.lastWeekLeaderboard?.slice(0, 3)}
                  players={fetchAllLeaderboardData?.lastWeekLeaderboard?.slice(3)}
                  rearrangedArray={rearrangedArray}
                  fetchAllLeaderboardData={fetchAllLeaderboardData}
                  isLoading={isLoading}
                  sortedArray={sortedArrayCurrent}
                  active={active}
                />
              )}
            </>
          ) : (
            <>
              {fetchAllLeaderboardData?.data?.length < 1 ? (
                <div className="leaderboardDataError">
                  <ErrorIcon />
                  No leaderboard data.
                </div>
              ) : (
                <Leaderboards
                  TopWinners={TopWinners}
                  players={players}
                  rearrangedArray={rearrangedArray}
                  fetchAllLeaderboardData={fetchAllLeaderboardData}
                  isLoading={isLoading}
                  sortedArray={sortedArrayCurrent}
                />
              )}
            </>
          )}
        </section>
      </main>

      <Socket setReloader={setReloader} quizID={quizID} />
    </AuthLayout>
  );
}
